// extracted by mini-css-extract-plugin
export var rootContainer = "Footer-module--rootContainer--1l8KW";
export var container = "Footer-module--container--2MRx4";
export var waves = "Footer-module--waves--21B2C";
export var row = "Footer-module--row--3OTdX";
export var column = "Footer-module--column--bnPdN";
export var header = "Footer-module--header--3NyKJ";
export var text = "Footer-module--text--1EjG7";
export var disclaimer = "Footer-module--disclaimer--1QaIC";